import React, { createContext, useEffect, useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import { getDatabase, ref, remove, onValue, set, off, update } from "firebase/database";
import { useSelector, useDispatch } from "react-redux";
import { IoMdGift } from 'react-icons/io';
import { setisfirsttime } from './actions';
import { setupdtoken ,setupdtoken2} from "./actions/index";
import { actlistData, catlistData, teamlistData, playerlistData } from "./actions/index";
import DataService from "./services/tutorial.service";

export const FirebaseContext = createContext();

export const FirebaseProvider = ({ children }) => {
    var flag = "1"
    var flag2 = "1"
    const isfirsttime = useSelector((state) => state.isfirsttime);

    const [upddata, setupddata] = useState(null);
    const [userupddata, setuserupddata] = useState(null);
    const [curid, setcurid] = useState(localStorage.getItem('auction_id'));
    const [firsttime, setfirsttime] = useState(isfirsttime);
    const loginuser = useSelector((state) => state.setUserlog);
    const [isActive, setActive] = useState(false);


    const [cid, setCid] = useState(loginuser["cid"]);
    const [token, settoken] = useState(loginuser["token"]);

    // const updtoken = useSelector((state) => state.updtoken);
    const updtoken = useSelector((state) => state.updtoken);

    const dispatch = useDispatch();
    const fetchaucpagedetail = async () => {

        setActive(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var val = {}
        // val.aid=aid;
        // val.faid = pltraid;
        await DataService.aucdetail(val, hdr)
            .then((res) => {
                console.log("api")

                let response = res.data;
                toast.dismiss(toastContainerId);
                console.log("response")
                console.log(response)

                if (response.success == true) {
                    if (response.data.detail.reg_player_on == 1) {
                        setcheck1(true)
                    }
                    console.log(response.data.detail.reg_player_on)
                    setaucdetail(response.data)
                    if (response.data.more[0].bg != "") {
                        setaucbackbox(response.data.fpath + response.data.more[0].bg)
                    }
                    if (response.data.more[0].sstamp != "") {
                        setaucstampbox(response.data.fpath + response.data.more[0].sstamp)
                    }
                    if (response.data.more[0].usstamp != "") {
                        setaucustampbox(response.data.fpath + response.data.more[0].usstamp)
                    }
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const fetchplData = async () => {
        console.log("aiiiiiid")
        // console.log(aid)
        setActive(true);

        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded", //v
                Authorization: JSON.stringify([
                    { cid: cid, aid: curid, token: loginuser["token"] },
                ]),
            },
        };

        await DataService.listPlayer({ self: 1 }, hdr)
            .then((res) => {
                let response = res.data;

                if (response.success == true) {
                    let responsedata = response.data;
                    console.log(responsedata)

                    dispatch(playerlistData({ responsedata }));
                }

                setActive(false);
            })
            .catch(() => {
                console.log("Not valid");
                setActive(false);
            });
        console.log("calling the player data")



    };
    const fetchteamData = async () => {
        setActive(true);

        var hdr = {
            params: {
                frm: 1,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([
                    { cid: cid, aid: curid, token: loginuser["token"] },
                ]),
            },
        };

        await DataService.listTeam({}, hdr)
            .then((res) => {
                let response = res.data;

                if (response.success == true) {
                    let responsedata = response.data;

                    dispatch(teamlistData({ responsedata }));
                }

                setActive(false);
            })
            .catch(() => {
                console.log("Not valid");
                setActive(false);
            });
        console.log("calling the team data")

    };
    const fetchcatData = async () => {

        setActive(true);

        var hdr = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                "Authorization": JSON.stringify([{ 'cid': cid, 'token': loginuser["token"] }])
            }
        }

        await DataService.listCategory({ 'aid': curid }, hdr)
            .then(res => {

                let response = res.data;

                if (response.success == true) {

                    let responsedata = response.data;
                    console.log(responsedata);
                    console.log("response data outer : " + responsedata)
                    dispatch(catlistData({ responsedata }));

                    if (refresh == 1) {
                        dispatch(getRefresh(0));
                    }
                }

                setActive(false);

            }).catch(() => {
                console.log('Not valid')
                setActive(false);
            })
        console.log("calling the cat data")

    };
    const fetchaucData = async () => {
        console.log("calling the auc data")
        // localStorage.removeItem('auction_id')

        setActive(true);
        console.log("fetch cid:" + cid);
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
            },
        };

        await DataService.listAuction({ myauction: 1 }, hdr)
            .then((res) => {
                let response = res.data;
                console.log(response);
                if (response.success == true) {
                    let responsedata = response.data;

                    dispatch(actlistData({ responsedata }));
                }

                setActive(false);
            })
            .catch(() => {
                console.log("Not valid");
                setActive(false);
            });

    };
    useEffect(() => {
        const generatedmytoken = generateToken(10);
        dispatch(setupdtoken2(generatedmytoken));
        const database = getDatabase();
        const databaseRef = ref(database, 'auction/info/user/' + cid);
        const userupdates = onValue(databaseRef, (snapshot) => {
            if (flag2 == "0") {

            var userdatasnap = snapshot.val();
            console.log('usersnap')
            console.log(userdatasnap)
            console.log(generatedmytoken)
            if (snapshot.exists() && (userdatasnap.tkn !== generatedmytoken)) {
                console.log("bhai token same h")

                console.log('userdatasnap');
                console.log(userdatasnap);
                setuserupddata(userdatasnap);
            }

            // setfirsttime(false)
        }
        else{
            flag2='0';
        }
        });
   
        return () => {
            userupdates();
        };

    }, [cid]);

    useEffect(() => {
        const database = getDatabase();
        const databaseRef = ref(database, 'auction/info/userauc/' + cid);
        const unsubscribe = onValue(databaseRef, (snapshot) => {
            var datasnap = snapshot.val();
            // setfirsttime(false)
            console.log(datasnap)
            setcurid(datasnap)
        });
        return () => {
            unsubscribe();
        };
    }, []);

    function generateToken(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let token = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            token += characters[randomIndex];
        }
        return token;
    }
    useEffect(() => {
        const generatedtoken = generateToken(10);
        dispatch(setupdtoken(generatedtoken));
        const database = getDatabase();
        const databaseRef2 = ref(database, 'auction/info/' + curid);
        const unsubscribe2 = onValue(databaseRef2, (snapshot) => {
            console.log("hhhhhhhhhhhhhhhhhhh")
            console.log(isfirsttime)
            if (flag == "0") {
                var datasnap2 = snapshot.val();
                console.log(datasnap2)
                console.log(datasnap2.tkn)
                console.log(token)
                if (snapshot.exists() && (datasnap2.tkn !== generatedtoken)) {
                    console.log("Data changed:", datasnap2);
                    if (datasnap2.upd == '4') {
                        const fetchData = async (t) => {
                            try {
                                if (t == '1') {
                                    await Promise.all([fetchaucData(), fetchteamData(), fetchcatData(), fetchplData()]);
                                }
                                else if (t == '2') {
                                    await Promise.all([fetchteamData()]);
                                }
                                else if (t == '3') {
                                    await Promise.all([fetchcatData()]);
                                }
                                else if (t == '4') {
                                    await Promise.all([fetchplData()]);
                                }
                                setupddata(datasnap2);

                            } catch (error) {
                                console.error('Error fetching data:', error);
                            }
                        };

                        fetchData(datasnap2.type);
                    }
                    else {

                        setupddata(datasnap2);
                    }
                }
            }
            else {
                flag = "0"
                console.log("second time enable")
                // setfirsttime(true)
            }

        });

        return () => {
            unsubscribe2();
        };
    }, [curid, firsttime]);

    return (
        <FirebaseContext.Provider value={{ upddata ,userupddata}}>
            {children}
        </FirebaseContext.Provider>
    );
};
